module.exports = __webpack_public_path__ + "static/media/5.bbd00e30.jpg";